export default "__VITE_ASSET__IgQlDJtU__"